import { ExGetterTree } from "vuex";
import { State, Getters, MenuType } from "./types";

const getters: ExGetterTree<State, Getters> = {
  isLoggedIn(state) {
    return !!state.partnerUser;
  },
  isScoutAgentMenuActive(state) {
    return state.menuType === MenuType.MENU_SCOUT_AGENT;
  }
};

export default getters;
